module.exports = __webpack_public_path__ + "img/credit.8eb3d563.png";